import { Actor, CollisionType, Color } from 'excalibur';

export class Brick extends Actor {
    constructor(options: { x: number; y: number; width: number; height: number; color: Color }) {
        super({ ...options, name: 'brick' });
        this.body.collisionType = CollisionType.Fixed;
    }
}
